import { getConfigForMeasuredTest } from 'Components/Worksheets/Config';
import { IConfigFunctionArgs } from 'Components/Worksheets/Core';
import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/MoistureConditionValueWorksheet/derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from 'Components/Worksheets/MoistureConditionValueWorksheet/measuredUsingConfig';
import { TestLocation } from 'Components/Worksheets/MoistureConditionValueWorksheet/types';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getDefaultBalanceConfig = ({ worksheet }: IConfigFunctionArgs) => {
  const testLocation = worksheet.data.Preparation.TestLocation;

  return {
    defaultUom: 'g',
    defaultReadability: testLocation === TestLocation.Laboratory ? '1' : '20',
  };
};

const getConfig = (prefix: string) =>
  mergeConfig(
    {
      [`${prefix}.Preparation.DropHeight`]: { uom: 'mm', format: { nearest: 1 } },
      [`${prefix}.Preparation.MassRetainedOn20_0mmSievePercentage`]: { format: { nearest: 0.1 } },
      [`${prefix}.Preparation.DryMassRetainedOn20_0mmSievePercentage`]: { format: { nearest: 0.1 } },
      [`${prefix}.Preparation.StabiliserAmount`]: { format: { nearest: 0.1 } },

      ...getConfigForMeasuredTest(
        qestIds.moistureContent.BS_EN_ISO_17892_1.rev2014,
        'data.Preparation.EmbeddedWaterContentTest'
      ),

      [`${prefix}.Measurements.Penetrations.Penetration`]: { uom: 'mm', format: { nearest: 0.1 } },
      [`${prefix}.Measurements.Penetrations.ChangeInPenetration`]: { uom: 'mm', format: { nearest: 0.1 } },

      [`${prefix}.Results.WaterContentPercent`]: { format: { nearest: 0.1 } },
    },
    getLabelConfig(prefix),
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    {
      [`${prefix}.Preparation.Balance`]: getDefaultBalanceConfig,
    }
  );

export { getConfig };

export default {
  [qestIds.moistureConditionValue.BS_EN_13286_46.rev2003]: getConfig,
};
